import { Button } from '../util/buttons';
import StartReviewButton from '../util/buttons/StartReviewButton';
import { REVIEW_TYPE_CONSULTANT } from '@rd-web-markets/shared/dist/util/constants';
import { isUserAdmin, isUserClaimGroupConsultant, isUserClaimGroupManager } from '../util/user/userUtils';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
export default function ButtonControls(_ref) {
  let {
    canShowStartTrackingChangesButton = true,
    company,
    claimGroup,
    reviewedObject,
    reviewedObjectClass,
    loading,
    createChangeSetForClient,
    createChangeSet,
    finalizeChangeSet,
    approveChangeSet,
    rejectChangeSet,
    buttonName,
    underManagerReviewButtonName = 'Under Manager Review',
    managerQAReviewButtonName = 'manager_review_completed',
    acceptChangesButtonText = 'accept_manager_review_changes',
    rejectChangesButtonText = 'reject_manager_review_changes',
    reviewType = REVIEW_TYPE_CONSULTANT,
    setModalShow
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const renderButton = () => {
    const differentReviewStarted = reviewedObject.active_change_set && reviewedObject.active_change_set.review_type !== reviewType;
    const reviewHasNotBeenStartedAndUserHasPrivileges = !reviewedObject.active_change_set && (isUserClaimGroupConsultant(user, reviewedObject) || isUserAdmin(user));
    const createChangeSetOrOpenModal = () => {
      if (reviewType === REVIEW_TYPE_CONSULTANT) {
        createChangeSet(reviewedObject, reviewedObjectClass, reviewType);
      } else {
        setModalShow(true);
      }
    };
    if (differentReviewStarted || reviewHasNotBeenStartedAndUserHasPrivileges) {
      return canShowStartTrackingChangesButton ? /*#__PURE__*/React.createElement(StartReviewButton, {
        text: buttonName,
        loading: loading,
        reviewedObject: reviewedObject,
        reviewedObjectClass: reviewedObjectClass,
        reviewType: reviewType,
        onClick: createChangeSetOrOpenModal
      }) : /*#__PURE__*/React.createElement(React.Fragment, null);
    } else if (reviewedObject.active_change_set && !reviewedObject.active_change_set.finalized_at) {
      if (isUserAdmin(user) || isUserClaimGroupManager(user, claimGroup)) {
        return /*#__PURE__*/React.createElement(Button, {
          onClick: () => finalizeChangeSet(reviewedObject),
          loading: loading,
          icon: "flag",
          disabled: reviewedObject.is_locked // is_locked only exists for claims at the moment
          ,
          iconPosition: "left",
          variant: "danger",
          size: "md"
        }, t(managerQAReviewButtonName));
      } else {
        return /*#__PURE__*/React.createElement(Button, {
          icon: "flag",
          disabled: true,
          iconPosition: "left",
          variant: "danger",
          size: "md"
        }, underManagerReviewButtonName);
      }
    } else if ((isUserAdmin(user) || isUserClaimGroupConsultant(user, reviewedObject)) && reviewedObject.active_change_set && reviewedObject.active_change_set.finalized_at) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: () => approveChangeSet(reviewedObject),
        className: "mx-2",
        loading: loading,
        icon: "done",
        disabled: reviewedObject.is_locked // is_locked only exists for claims at the moment
        ,
        iconPosition: "left",
        variant: "success",
        size: "md"
      }, t(acceptChangesButtonText)), /*#__PURE__*/React.createElement(Button, {
        onClick: () => rejectChangeSet(reviewedObject),
        loading: loading,
        icon: "close",
        disabled: reviewedObject.is_locked // is_locked only exists for claims at the moment
        ,
        iconPosition: "left",
        variant: "danger",
        size: "md"
      }, t(rejectChangesButtonText)));
    }
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "mt-5 mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "text-center"
  }, renderButton()));
}